import { errorCallback, successCallback } from '@/composables/validate';


export async function GetCatalogueProducts({ datasetId }) {
  return this.handleApiRequest({ 
    method: `staff/GetCatalogueProducts?DatasetId=${datasetId}`,
    request: window.enum.request.GET,
    errorCallback
  })
}

export async function GetCatalogueProductsWithClearances(datasetId) {
  return this.handleApiRequest({ 
    method: `staff/GetCatalogueProductsWithClearances?DatasetId=${datasetId}`,
    request: window.enum.request.GET,
    errorCallback
  })
}

export async function UpdateCatalogueGlassClearances({ DatasetId, GlassClearances }) {
  return this.handleApiRequest({ 
    method: 'staff/UpdateCatalogueGlassClearances',
    payload: {
      DatasetId,
      GlassClearances
    },
    errorCallback,
    successCallback: (r) => successCallback(r.data, 'Save')
  })
}

export async function GetSimpleProducts({ datasetId, typeId }) {
  return this.handleApiRequest({ 
    method: `staff/GetSimpleProducts?DatasetId=${datasetId}&TypeId=${typeId}`,
    request: window.enum.request.GET,
    errorCallback
  })
}

export async function GetGlassFinancials({ datasetId, productId }) {
  return this.handleApiRequest({ 
    method: `staff/GetGlassFinancials?DatasetId=${datasetId}&ProductId=${productId}`,
    request: window.enum.request.GET,
    errorCallback
  })
}

export async function GetPanelFinancials({ datasetId, productId }) {
  return this.handleApiRequest({ 
    method: `staff/GetPanelFinancials?DatasetId=${datasetId}&ProductId=${productId}`,
    request: window.enum.request.GET,
    errorCallback
  })
}

export async function UpdatePanelFinancials(payload) {
  return this.handleApiRequest({ 
    method: 'staff/UpdatePanelFinancials',
    payload,
    errorCallback,
    successCallback: (r) => successCallback(r.data, 'Save')
  })
}

export async function UpdateGlassFinancials(payload) {
  return this.handleApiRequest({ 
    method: 'staff/UpdateGlassFinancials',
    payload,
    errorCallback,
    successCallback: (r) => successCallback(r.data, 'Save')
  })
}

export async function GetCatalogueProductsForOverlaps({ datasetId }) {
  return this.handleApiRequest({ 
    method: `staff/GetCatalogueProductsForOverlaps?DatasetId=${datasetId}`,
    request: window.enum.request.GET,
    errorCallback
  })
}

export async function GetCatalogueOptionsForOverlaps({ datasetId, productId }) {
  return this.handleApiRequest({ 
    method: `staff/GetCatalogueOptionsForOverlaps?DatasetId=${datasetId}&ProductId=${productId}`,
    request: window.enum.request.GET,
    errorCallback
  })
}

export async function UpdateCatalogueSashOverlaps(payload) {
  return this.handleApiRequest({ 
    method: 'staff/UpdateCatalogueSashOverlaps',
    payload,
    errorCallback,
    successCallback: (r) => successCallback(r.data, 'Save')
  })
}